import { connect } from 'react-redux';
import { getIsUnverified, getVerificationLoadingState } from '../../../publicSession/selectors';
import { resendVerificationEmail } from '../../../publicSession/actions';
const mapStateToProps = (state)=>Object.assign({}, getVerificationLoadingState(state), {
        isUnverified: getIsUnverified(state)
    });
const mapDispatchToProps = {
    resendEmail: resendVerificationEmail
};
export default connect(mapStateToProps, mapDispatchToProps);
